import { inspectionsService } from '@/services/inspections';
import type { InspectionHistoryApiResponse } from '@/services/inspections/types';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

interface UseInspectionHistoryOptions {
  enabled?: boolean;
}

export function useInspectionHistory(
  policyId: string | null | undefined,
  options: UseInspectionHistoryOptions = {}
) {
  const { enabled = true } = options;

  return useQuery<InspectionHistoryApiResponse>({
    queryKey: ['inspection-history', policyId],
    queryFn: async () => {
      if (!policyId?.trim()) {
        throw new Error('PolicyId inválido');
      }

      const response = await inspectionsService.getInspectionHistory(policyId);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar histórico de inspeções'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
    enabled: enabled && Boolean(policyId?.trim()),
  });
}
